import { createRoot } from "react-dom/client";
import React from "react";
import { App as AntdApp, ConfigProvider } from "antd";
import { BrowserRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react';
import colors from 'tailwindcss/colors';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthorizedApolloProvider from './AuthorizedApolloProvider';
import ErrorModal from "./components/modals/ErrorModal";

import "./index.css";

const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT,
};

const root = createRoot(document.getElementById("root"));

root.render(
  <RollbarProvider config={rollbarConfig}>
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            wireframe: true
          }
        },
        token: {
          colorPrimary: colors.indigo['600']
        }
      }}
    >
      <AntdApp>
        <ErrorBoundary fallbackUI={ErrorModal}>
          <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
            audience={process.env.REACT_APP_AUTH0_API_IDENTIFIER}
            redirectUri={window.location.origin}
            // On localhost Auth0 cannot skip the consent screen, so silent
            // re-auth (prompt=none) fails with consent_required after a reload.
            // Persist tokens in localstorage in dev so the session survives
            // reloads without relying on the silent-auth iframe.
            cacheLocation={process.env.NODE_ENV === 'development' ? 'localstorage' : 'memory'}
          >
            <BrowserRouter>
              <React.StrictMode>
                <AuthorizedApolloProvider>
                  <App />
                </AuthorizedApolloProvider>
              </React.StrictMode>
            </BrowserRouter>
          </Auth0Provider>
        </ErrorBoundary>
      </AntdApp>
    </ConfigProvider>
  </RollbarProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
